import React from "react";
import {
  Image,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import { AppImages } from "../../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";

const NoBalancePopup = ({ showPopup, closePopup }) => {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();

  return (
    <Modal
      transparent={true}
      visible={showPopup}
      onRequestClose={closePopup}
      animationType="fade"
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.76)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: AppColors.black_121212,
            padding:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 10
                : 20,
            marginVertical: 20,
            borderRadius: 10,
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "95%"
                : "30%",
            alignItems: "center",
            borderWidth: 1,
            borderColor: AppColors.gray_9F9F9F,
          }}
        >
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_16
                  : AppFontStyle.BOLD_ANYBODY_20,
                { flex: 1 },
              ]}
            >
              No Balance
            </Text>
          </View>
          <Separator
            color={AppColors.appBlackColor_1e1e1e}
            height={2}
            marginTop={10}
            marginBottom={10}
            marginHorizontal={0}
          />
          <Text style={[AppFontStyle.REGULAR_ANYBODY_16, { lineHeight: 20 }]}>
            You currently have no balance available to create an event. Please
            purchase tokens to proceed.
          </Text>
          <CommonButton
            buttonStyle={{
              paddingVertical: 14,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
              shadowOpacity: 0,
              width: "100%",
              marginTop: 10,
              flex: 1,
            }}
            textStyle={[
              AppFontStyle.BOLD_ANYBODY_12,
              { color: AppColors.white },
            ]}
            title="Purchase Token"
            onTap={() => {
              navigateToScreen(navigation, AppScreens.PurchaseScreen);
              closePopup();
            }}
          />
        </View>
      </View>
    </Modal>
  );
};

export default NoBalancePopup;
